import http from '../plugins/axios';
const BASE_URI = '/topic';
export default {
    getTopicsByDegreeType({
        degreeType
    }) {
        return http.get(`${BASE_URI}?degreeType=${degreeType}`)
    }
}
